import React, { FC } from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import * as AT from "../../../state/actionTypesB2B";
import * as BUSINESS_DETAILS_SELECTORS from "../../../state/selectors/businessDetailsSelectors";
import TEXT from "../../../text-consts";

interface B2BPersonalDetailsContinueButtonProps {
    isSettingBusinessDetails: boolean;
    shouldShowInputFields: boolean;
}

const B2BPersonalDetailsContinueButton: FC<B2BPersonalDetailsContinueButtonProps> = ({
    isSettingBusinessDetails,
    shouldShowInputFields,
}) => (
    <Button
        className="beta-checkout__continue-button-container__button"
        id="business-details-form-button"
        form={FORM_ID.BUSINESS_DETAILS}
        loading={isSettingBusinessDetails}
        variant="primary"
        disabled={!shouldShowInputFields || isSettingBusinessDetails}
        type="submit"
    >
        {TEXT.COMMON.CONTINUE}
    </Button>
);

const mapStateToProps = (state: RootState) => ({
    isSettingBusinessDetails: LOADING_SELECTORS.isTypeLoading(state, AT.B2B_SUBMIT_BUSINESS_DETAILS),
    shouldShowInputFields: BUSINESS_DETAILS_SELECTORS.shouldShowInputFields(state),
});

export default connect(mapStateToProps)(B2BPersonalDetailsContinueButton);
